import * as React from "react";
import PropTypes from "prop-types";
import { DialogContent, DialogContentText } from "@material-ui/core";
import { realisticConfetti } from "../../util/confetti";

const CompleteSection = React.memo(function CompleteSection({
  purchaseDetails,
}) {
  React.useEffect(() => {
    realisticConfetti();
  }, []);

  return (
    <DialogContent>
      <DialogContentText>
        Awesome, your purchase is complete! We've sent a confirmation email to{" "}
        {purchaseDetails.email}.
      </DialogContentText>
    </DialogContent>
  );
});

CompleteSection.propTypes = {
  purchaseDetails: PropTypes.shape({
    email: PropTypes.string,
  }),
};

export default CompleteSection;
